<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { onMounted } from "vue";
import { initFlowbite } from "flowbite";
onMounted(() => {
    initFlowbite();
});
import { Head, Link, usePage, useForm, router } from "@inertiajs/vue3";
import { computed, reactive, ref } from "vue";
import { helperStore } from "@/store/helper";
const showMobileMenu = ref("false");
const helper = helperStore();
const page = usePage();

const company = page.props.shared_data.company;

const canLogin = page.props.canLogin;
const canRegister = page.props.canRegister;
const auth = page.props.auth;
const primaryPhone = company["phone"].split(",");

const isModalOpen = ref(false);
const activeTab = ref("login");
const showBooking = ref(true);

const openModal = () => {
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const setActiveTab = (tab) => {
    activeTab.value = tab;
};
const handleReload = () => {
    location.reload();
};

const form = useForm({
    name: "",
    email: "",
    password: "",
    phone: "",
    password_confirmation: "",
});

const login = () => {
    try {
        form.post(route("login"), {
            onSuccess: (page) => {
                closeModal();
                router.visit("/");
                successToast(page.props.flash.message);
            },
        });
    } catch (error) {
        errorToast("Something went wrong!");
    }
};
const register = () => {
    try {
        form.post(route("register"), {
            onSuccess: (page) => {
                closeModal();
                router.visit("/");
                successToast(page.props.flash.message);
            },
        });
    } catch (error) {
        errorToast("Something went wrong!");
    }
};

const logout = () => {
    try {
        form.post(route("logout"), {
            onSuccess: (page) => {
                closeModal();
                router.visit("/");
                successToast(page.props.flash.message);
            },
        });
    } catch (error) {
        errorToast("Something went wrong!");
    }
};

const nameErrorClear = () => {
    return form.clearErrors("name");
};
const emailErrorClear = () => {
    return form.clearErrors("email");
};
const phoneErrorClear = () => {
    return form.clearErrors("phone");
};
const passwordErrorClear = () => {
    return form.clearErrors("password");
};
const password_confirmationErrorClear = () => {
    return form.clearErrors("password_confirmation");
};
</script>

<template>
    <div class="xl:px-8 px-4">
        <nav class="bg-white fixed top-0 left-0 right-0 z-50 xl:px-8 px-4">
            <div
                class="flex flex-wrap items-center justify-between lg:p-2 py-2"
            >
                <Link
                    :href="route('home.page')"
                    class="cursor-pointer"
                    rel="preload"
                    as="image"
                >
                    <!-- <img
                        :src="company?.logo"
                        alt="Company Logo"
                        width="225"
                        height="auto"
                        decoding="async"
                        class="xl:w-[225px] sm:w-[150px] w-[144px] h-auto object-contain"
                    /> -->
                    <!-- <div class=""> -->
                    <div class="">

                        <img src="/hero_banners/nochinta.jpg" 
                            loading="eager" class="xl:w-[225px] sm:w-[150px] w-full sm:block hidden"
                            alt="Hero Banner">
                        <img src="/hero_banners/nochinta-mobile.webp" 
                            loading="eager" class="w-full aspect-[150/38] object-cover sm:hidden block"
                            alt="Hero Banner">
                    </div>
                    
                </Link>
                <ul class="flex justify-end items-center min-h-[40px] gap-4 pr-6">
                    <li
                        class="lg:hidden w-[80px] h-[40px] flex items-center justify-center text-sm py-0 px-0 mr-2"
                    >
                        <label for="language-selector" class="sr-only"
                            >Select Language</label
                        >
                        <select
                            id="language-selector"
                            name="language"
                            class="form-control top-selector language_switcher border border-gray-200 cursor-pointer rounded-sm text-sm px-1 py-1"
                            v-model="locale"
                        >
                            <option
                                v-for="locale in $i18n.availableLocales"
                                :key="`locale-${locale}`"
                                :value="locale"
                            >
                                {{ locale }}
                            </option>
                        </select>
                    </li>
                    <!-- <li class="lg:hidden">
                        <Link :href="route('customers.login')"
                                class="block font-semibold bg-white hover:bg-blue-50 text-[#0966E5] text-sm rounded-sm py-1 px-2 border border-[#84b6e7] hover:border-[#0966E5]"
                                type="button">{{ $t('nav.pay') }}
                            </Link>
                    </li> -->
                    <li
                        v-if="auth.user"
                        class="flex lg:hidden w-[80px] h-[40px] items-center justify-center transition duration-300"
                    >
                        <Link
                            :href="route('dashboard')"
                            class="block font-semibold bg-white hover:bg-blue-50 text-[#0966E5] text-sm rounded-sm py-1 px-2 border border-[#84b6e7] hover:border-[#0966E5]"
                            aria-current="page"
                            >{{ $t("nav.dashboard") }}</Link
                        >
                    </li>
                    <li
                        v-else
                        class="flex w-[80px] h-[40px] items-center justify-center space-x-2 lg:hidden transition duration-300"
                    >
                        <button
                            @click="openModal"
                            class="block font-semibold bg-white hover:bg-blue-50 text-[#0966E5] text-sm rounded-sm py-1 px-2 border border-[#84b6e7] hover:border-[#0966E5]"
                            type="button"
                        >
                            {{ $t("nav.login") }}
                        </button>
                    </li>
                </ul>
                <button
                    data-collapse-toggle="navbar-dropdown"
                    type="button"
                    class="inline-flex items-center w-10 h-10 justify-center text-sm text-gray-800 lg:hidden bg-transparent focus:outline-none"
                    aria-controls="navbar-dropdown"
                    aria-expanded="false"
                >
                    <span class="sr-only">Open main menu</span>
                    <svg
                        class="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14"
                    >
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 1h15M1 7h15M1 13h15"
                        />
                    </svg>
                </button>

                <div
                    class="w-full lg:block lg:w-auto z-50"
                    :class="{ hidden: showMobileMenu }"
                    id="navbar-dropdown"
                >
                    <ul
                        class="flex justify-center lg:items-center flex-col font-medium p-2 md:p-0 mt-4 rounded-lg lg:flex-row xl:space-x-3 lg:space-x-1 md:mt-0 border-b-1 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700"
                    >
                        <li
                            class="py-2 xl:px-2 lg:px-1 px-2 bg-white hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] rounded-md transition duration-300"
                        >
                            <Link
                                :href="route('services.page')"
                                class="text-black xl:text-[18px] lg:text-[13px] text-[16px]"
                                aria-current="page"
                                :class="{
                                    'py-2 px-2 bg-[#D3EDF0] bg-opacity-[0.3] rounded-md':
                                        $page.url.startsWith('/services'),
                                }"
                            >
                                {{ $t("nav.our_services") }}</Link
                            >
                        </li>
                        <li
                            class="py-2 xl:px-2 lg:px-1 px-2 bg-white hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] rounded-md transition duration-300"
                        >
                            <Link
                                :href="route('about.page')"
                                class="text-black xl:text-[18px] lg:text-[13px] text-[16px]"
                                aria-current="page"
                                :class="{
                                    'py-2 px-2 bg-[#D3EDF0] bg-opacity-[0.3] rounded-md':
                                        $page.url === '/about',
                                }"
                            >
                                {{ $t("nav.about_us") }}
                            </Link>
                        </li>
                        <li
                            class="py-2 xl:px-2 lg:px-1 px-2 bg-white hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] rounded-md transition duration-300"
                        >
                            <Link
                                :href="route('gallery.page')"
                                class="text-black xl:text-[18px] lg:text-[13px] text-[16px]"
                                aria-current="page"
                                :class="{
                                    'py-2 px-2 bg-[#D3EDF0] bg-opacity-[0.3] rounded-md':
                                        $page.url === '/gallery',
                                }"
                            >
                                {{ $t("nav.gallery") }}
                            </Link>
                        </li>

                        <li
                            class="py-2 xl:px-2 lg:px-1 px-2 bg-white hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] rounded-md transition duration-300"
                        >
                            <Link
                                :href="route('blog.page')"
                                class="text-black xl:text-[18px] lg:text-[13px] text-[16px]"
                                aria-current="page"
                                :class="{
                                    'py-2 px-2 bg-[#D3EDF0] bg-opacity-[0.3] rounded-md':
                                        $page.url.startsWith('/blog'),
                                }"
                            >
                                {{ $t("nav.blog") }}</Link
                            >
                        </li>
                        <li
                            class="py-2 xl:px-2 lg:px-1 px-2 bg-white hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] rounded-md transition duration-300"
                        >
                            <Link
                                :href="route('contact.page')"
                                class="text-black xl:text-[18px] lg:text-[13px] text-[16px]"
                                aria-current="page"
                                :class="{
                                    'py-2 px-2 bg-[#D3EDF0] bg-opacity-[0.3] rounded-md':
                                        $page.url === '/contact',
                                }"
                            >
                                {{ $t("nav.contact") }}</Link
                            >
                        </li>
                        <li
                            class="flex items-center justify-start space-x-2 mb-2"
                        >
                            <a
                                :href="company?.fb"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="block text-[#0966E5] text-2xl lg:py-2 lg:px-3 py-1 px-2 hover:bg-gray-100 rounded-full"
                                aria-label="Visit Facebook page"
                            >
                                <i class="fa-brands fa-facebook"></i>
                            </a>

                            <a
                                :href="company?.yt"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="block text-[#E10A00] text-2xl lg:py-2 lg:px-3 py-1 px-2 hover:bg-gray-100 rounded-full"
                                aria-label="Visit YouTube channel"
                            >
                                <i class="fa-brands fa-youtube"></i>
                            </a>

                            <a
                                :href="`tel:` + primaryPhone[0]"
                                class="flex lg:items-center lg:justify-center text-[#1976D2] xl:text-[17px] lg:text-[13px]"
                                aria-current="page"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    class="w-5 h-5 mr-2"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                                {{ primaryPhone[0] }}</a
                            >
                        </li>
                        <li
                            :class="[
                                'flex items-center justify-center bg-primary hover:bg-[#1565C0] rounded transition duration-300',
                                showBooking ? 'opacity-100' : 'opacity-0',
                            ]"


                        >
                            <Link
                                :href="route('booking.page')"
                                class="font-medium text-gray-900 text-base bg-primary hover:bg-[#1565C0] px-3 py-3 rounded transition duration-300"
                                aria-current="page"
                            >
                                {{ $t("nav.booking") }}
                            </Link>
                        </li>

                        <!-- <li class="flex items-center justify-center px-3 py-2 border bg-[#1CBED1] hover:bg-[#1565C0] rounded shadow-2xl transition duration-300">
                            <Link :href="route('customers.login')" class="font-semibold text-white text-base"
                                type="button">{{ $t('nav.pay') }}
                            </Link>
                        </li>-->
                        <li
                            class="lg:flex hidden items-center justify-center py-1 px-1"
                        >
                            <label for="langId" class="sr-only"
                                >Select Language</label
                            >
                            <select
                                name="lang"
                                id="langId"
                                class="form-control top-selector language_switcher border border-gray-200 cursor-pointer rounded-sm"
                                v-model="locale"
                            >
                                <option
                                    v-for="locale in $i18n.availableLocales"
                                    :key="`locale-${locale}`"
                                    :value="locale"
                                >
                                    {{ locale }}
                                </option>
                            </select>
                        </li>

                        <li
                            v-if="auth.user"
                            class="rounded sm:mt-0 mt-1"
                        >
                            <button
                                type="button"
                                class="flex mx-3 w-10 h-10 text-sm rounded-full"
                                id="user-menu-button"
                                aria-expanded="false"
                                data-dropdown-toggle="dropdown"
                            >
                                <span class="sr-only">Open user menu</span>
                                
                                <img
                                    class="w-full h-full rounded-full"
                                    src="/assets/images/common/no_avater.webp"
                                    alt="user photo" loading="lazy"
                                />
                            </button>
                            <div
                                class="hidden z-50 my-4 w-56 text-base list-none bg-white divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 rounded-xl"
                                id="dropdown"
                            >
                                <div class="py-3 px-4">
                                    <span
                                        class="block text-sm font-semibold text-gray-900 dark:text-white"
                                        >{{ $page.props.auth.user?.name }}</span
                                    >
                                    <span
                                        class="block text-sm text-gray-900 truncate dark:text-white"
                                        >{{
                                            $page.props.auth.user?.email
                                        }}</span
                                    >
                                </div>
                                <ul
                                    class="py-1 text-gray-700 dark:text-gray-300"
                                    aria-labelledby="dropdown"
                                >
                                    <li>
                                        <Link
                                            :href="route('profile.edit')"
                                            class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                                        >
                                            My profile</Link
                                        >
                                    </li>
                                </ul>
                                <ul
                                    class="py-1 text-gray-700 dark:text-gray-300"
                                    aria-labelledby="dropdown"
                                >
                                    <li>
                                        <Link
                                            :href="route('dashboard')"
                                            class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                                        >
                                            Dashboard</Link
                                        >
                                    </li>
                                </ul>
                                <ul
                                    class="py-1 text-gray-700 dark:text-gray-300"
                                    aria-labelledby="dropdown"
                                >
                                    <li>
                                        <span
                                            @click.prevent="logout"
                                            class="cursor-pointer w-full text-left block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                                        >
                                            Sign out</span
                                        >
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li
                            v-else
                            class="lg:flex hidden rounded transition duration-300 space-x-2"
                        >
                            <button
                                @click="openModal"
                                class="block font-semibold bg-white hover:bg-blue-50 text-[#0966E5] px-3 py-2 rounded border border-[#84b6e7] hover:border-[#0966E5]"
                                type="button"
                            >
                                {{ $t("nav.login") }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div
                v-if="isModalOpen"
                class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25 backdrop-filter backdrop-blur-sm"
            >
                <div class="absolute inset-0"></div>
                <!-- This div ensures that the backdrop blurs properly -->
                <div class="relative p-4 w-full max-w-2xl">
                    <!-- Modal content -->
                    <div class="relative bg-white">
                        <!-- Modal header -->
                        <div
                            class="flex items-center justify-between p-0 md:p-2 rounded-t"
                        >
                            <button
                                type="button"
                                @click="closeModal"
                                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            >
                                <svg
                                    class="w-3 h-3"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 14 14"
                                >
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                    />
                                </svg>
                                <span class="sr-only">Close modal</span>
                            </button>
                        </div>
                        <!-- Modal body -->
                        <div class="relative bg-white">
                            <div class="flex justify-center items-center p-2">
                                <div class="mx-auto">
                                    <div
                                        class="sm:w-[250px] w-[150px] sm:h-full flex items-center justify-center mx-auto"
                                    >
                                        <img
                                            src="/assets/images/nochinta.webp"
                                            class="h-full w-full object-cover object-top inline-block"
                                            alt=""
                                        />
                                    </div>
                                    <h2
                                        class="text-center title-font sm:text-xl text-base font-medium text-gray-700 sm:mt-4 mt-2 leading-relaxed"
                                    >
                                        <span v-show="activeTab === 'login'"
                                            >Login using your mobile
                                            number</span
                                        ><span v-show="activeTab === 'register'"
                                            >Register with the required
                                            information</span
                                        >
                                    </h2>
                                </div>
                            </div>
                            <!-- Login form  -->
                            <div
                                class="sm:py-6 py-2 sm:px-20 px-6 mx-auto"
                                v-show="activeTab === 'login'"
                            >
                                <form @submit.prevent="login">
                                    <div class="mb-4">
                                        <input
                                            v-model="form.email"
                                            @change="emailErrorClear()"
                                            type="email"
                                            id="loginemail"
                                            name="email"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Email address"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 mb-6"
                                        >
                                            {{ form.errors.email }}
                                        </p>
                                    </div>
                                    <div class="mb-4">
                                        <input
                                            v-model="form.password"
                                            @change="passwordErrorClear()"
                                            type="password"
                                            id="password"
                                            name="password"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Enter password"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 mb-6"
                                        >
                                            {{ form.errors.password }}
                                        </p>
                                    </div>
                                    <button
                                        type="submit"
                                        class="flex w-full text-center justify-center items-center text-white bg-primary border-0 sm:py-2 py-1 px-8 focus:outline-none hover:bg-[#1565C0] transition duration-300 rounded sm:text-lg text-base uppercase"
                                        :class="{
                                            'opacity-25': form.processing,
                                        }"
                                        :disabled="form.processing"
                                    >
                                        Continue
                                    </button>
                                </form>
                                <div
                                    class="text-center title-font sm:text-base text-sm font-medium text-gray-700 leading-relaxed sm:py-6 py-3"
                                >
                                    Don't have an account?
                                    <button
                                        @click="setActiveTab('register')"
                                        class="text-[#1565C0] uppercase sm:text-[15px] text-[12px] bg-transparent sm:px-4 px-1 py-2 hover:bg-gray-50"
                                    >
                                        Register Now
                                    </button>
                                </div>
                            </div>
                            <!-- Register form  -->
                            <div
                                class="sm:py-6 py-2 sm:px-20 px-6 mx-auto"
                                v-show="activeTab === 'register'"
                            >
                                <form @submit.prevent="register">
                                    <div class="mb-2">
                                        <input
                                            v-model="form.name"
                                            @change="nameErrorClear()"
                                            type="text"
                                            id="reg_name"
                                            name="reg_name"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Full Name"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2"
                                        >
                                            {{ form.errors.name }}
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            v-model="form.email"
                                            @change="emailErrorClear()"
                                            type="email"
                                            id="reg_email"
                                            name="reg_email"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Email Address"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2"
                                        >
                                            {{ form.errors.email }}
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            v-model="form.phone"
                                            @change="phoneErrorClear()"
                                            type="text"
                                            id="phone"
                                            name="phone"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Mobile Number"
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2"
                                        >
                                            {{ form.errors.phone }}
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            v-model="form.password"
                                            @change="passwordErrorClear()"
                                            type="password"
                                            id="reg_password"
                                            name="reg_password"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Password"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2"
                                        >
                                            {{ form.errors.password }}
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            v-model="form.password_confirmation"
                                            @change="
                                                password_confirmationErrorClear()
                                            "
                                            type="password"
                                            id="res_c_password"
                                            name="res_c_password"
                                            class="w-full border border-gray-300 bg-white hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                                            placeholder="Confirmation Password"
                                            required
                                        />
                                        <p
                                            class="text-red-600 dark:text-red-300 xl:mb-6 lg:mb-4 mb-2"
                                        >
                                            {{
                                                form.errors
                                                    .password_confirmation
                                            }}
                                        </p>
                                    </div>
                                    <button
                                        type="submit"
                                        class="flex w-full text-center justify-center items-center text-white bg-primary border-0 sm:py-2 py-1 px-8 focus:outline-none hover:bg-[#1565C0] transition duration-300 rounded sm:text-lg text-base uppercase"
                                    >
                                        Register
                                    </button>
                                </form>
                                <div
                                    class="text-center title-font sm:text-base text-sm font-medium text-gray-700 leading-relaxed sm:py-4 py-3"
                                >
                                    Already have an account?
                                    <button
                                        @click="setActiveTab('login')"
                                        class="text-[#1565C0] uppercase sm:text-[15px] text-[12px] bg-transparent sm:px-4 px-1 py-2 hover:bg-gray-50"
                                    >
                                        Go To Login
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<style scoped>
#navbar-dropdown {
    min-height: 60px; /* Match visible height */
}
</style>
